import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"download-button",attrs:{"href":_vm.convertData,"download":`${_vm.fileName}.${_vm.fileType}`}},[_c(VIcon,[_vm._v("download")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }